<div class="wheel" [class.cancelled]="cancelled" [class.planned]="isCurrentPlanned()" [style.--size.px]="size">
  <div class="ring" [style.--p]="displayProgressPercent" [style.--p2]="displayPlannedProgressPercent"></div>
  <div class="stations">
    @for (node of nodes; track node.id; let i = $index) {
      <div class="station" [style.--angle.deg]="angleFor(i)">
        <span
          class="station-dot"
          [class]="node.status"
          [class.planned]="isPlanned(node)"
          (mouseenter)="hoveredNode.set(node)"
          (mouseleave)="hoveredNode.set(null)"
        ></span>
      </div>
    }
  </div>
  <svg class="detours" [attr.viewBox]="'0 0 ' + size + ' ' + size">
    @for (detour of childDetours(); track $index) {
      <path [attr.d]="detour.pathD" class="detour-bg"></path>
      <path
        [attr.d]="detour.pathD"
        class="detour-fill"
        [style.--path-len.px]="detour.pathLen"
        [style.--fill-len.px]="displayFillLen(detour.nodeId)"
      ></path>
    }
  </svg>
  @for (detour of childDetours(); track $index) {
    @for (dot of detour.dots; track dot.node.id) {
      <div class="child-station" [style.--angle.deg]="dot.angleDeg">
        <span
          class="station-dot child-dot"
          [class]="dot.node.status"
          [class.planned]="isPlanned(dot.node)"
          [style.animation-delay.ms]="dot.revealDelayMs"
          (mouseenter)="hoveredNode.set(dot.node)"
          (mouseleave)="hoveredNode.set(null)"
        ></span>
      </div>
    }
  }
  <div class="center">
    @if (cancelled) {
      <div class="center-label">Order canceled</div>
    } @else {
      @if (displayNode(); as node) {
        <div class="center-label">{{ statusLabel(node.status) }}</div>
        <div class="center-value">{{ node.name }}</div>
        @if (node.asIsDate) {
          <div class="center-date">{{ node.asIsDate | yomaDateFormat: 'eeeeee. dd.MM.yyyy' }}</div>
        }
        @if (node.toBeDate) {
          <div class="center-date planned">geplant: {{ node.toBeDate | yomaDateFormat: 'eeeeee. dd.MM.yyyy' }}</div>
        }
      } @else {
        <div class="center-label">Ausgeliefert</div>
      }
    }
  </div>
</div>
